var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-group clearfix width-xs-34rem"data-bind="visibleAnimated:Categories.api.visibleSection.isLifeSection(),with: ContactInfo"> <div class="padding-left-0 padding-right-0 col-xs-12 control-label">Укажите номер любого Вашего договора(полиса) в ООО "СК "РГС-Жизнь", это позволит Компании максимально быстро ответить на Ваше обращение. Если Вы затрудняетесь указать информацию, оставьте поле пустым.</div> <div class="padding-left-0 padding-right-0 col-xs-12"><input class="form-control"data-bind="value:LifePolicy"></div> </div>';
}
return __p;
};
